module.exports = __webpack_public_path__ + "img/alka_seltzer_plus_powerfast_fizz.b5228a14.png";